const identity = JSON.parse(window.localStorage.getItem('identity'))
export default function getApiUrl(url) {
    return `${process.env.REACT_APP_API}${url.includes('?') ? `${url}&` : `${url}?`}user=${identity.login}&password=${
        identity.password
    }`
}
